// https://css-tricks.com/snippets/javascript/javascript-keycodes/
export default {
  END: 35,
  HOME: 36,
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40,
  PLUS: 187,
  MINUS: 189,
  ZERO: 48,
}
